<template>
  <div v-if="apptemp">
    <TransitionRoot appear :show="showModal" as="template">
      <Dialog as="div" @close="closeModal">
        <div class="fixed inset-0 z-30 overflow-y-auto">
          <div class="min-h-screen text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-10"
              leave="duration-200 ease-in"
              leave-from="opacity-10"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="transition ease-in-out duration-700 transform"
              enter-from="translate-y-full scale-0"
              enter-to="translate-y-0 scale-100"
              leave="transition ease-in-out duration-700 transform"
              leave-from="translate-y-0"
              leave-to="translate-y-full"
            >
              <div
                class="inset-x-0 bottom-0 absolute w-full overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg py-5"
              >
                <div class="pb-5 px-4">
                  <h2 class="text-lg text-brand-black">
                    {{ apptemp.name }}
                  </h2>
                  <p class="text-sm italic text-brand-mid-gray">
                    {{ origin }}/apply/{{ apptemp.slug }}
                  </p>

                  <div class="py-1 flex flex-col">
                    <div>
                      <div
                        class="rounded-lg inline-block py-1 px-1 my-1 mr-1"
                        v-for="type in apptemp.available_report_sources"
                        :key="`${apptemp.slug}-${type}`"
                        :class="[
                          apptemp.selected_report_sources.includes(type) ||
                          apptemp.selected_report_sources.join(',').includes(type)
                            ? 'bg-brand-background-light-blue'
                            : 'bg-brand-light-gray'
                        ]"
                      >
                        <p
                          :class="[
                            'text-2xs capitalize',
                            apptemp.selected_report_sources.includes(type) ||
                            apptemp.selected_report_sources.join(',').includes(type)
                              ? 'text-brand-blue'
                              : 'text-brand-dark-gray'
                          ]"
                        >
                          {{ type }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="flex flex-row pt-1"
                      v-if="apptemp.selected_report_sources.length === 0"
                    >
                      <div class="flex items-center">
                        <ExclamationIcon class="w-5 h-5 pr-1 text-brand-yellow" />
                      </div>
                      <div class="flex items-center">
                        <p class="text-brand-yellow text-2xs">0 Reports</p>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-col pt-3">
                    <div
                      class="flex flex-row border-b border-brand-light-gray py-2 cursor-pointer"
                      @click="openShareModal"
                    >
                      <div class="flex items-center">
                        <PaperPlaneIcon :classes="'w-8 h-7 text-brand-green'" />
                      </div>
                      <div class="flex items-center pl-3">
                        <p class="text-base">Send</p>
                      </div>
                    </div>

                    <router-link
                      :to="{
                        name: 'dashboard_form_settings',
                        params: { slug: apptemp.slug }
                      }"
                      class="flex flex-row border-b border-brand-light-gray py-2 cursor-pointer focus:border-0"
                    >
                      <div class="flex items-center">
                        <CogIcon class="w-8 h-8 text-brand-green" />
                      </div>
                      <div class="flex items-center pl-3">
                        <p class="text-base">Settings</p>
                      </div>
                    </router-link>

                    <router-link
                      :to="{
                        name: 'apply_form',
                        params: { slug: apptemp.slug },
                        query: { preview: true }
                      }"
                      class="flex flex-row border-b border-brand-light-gray py-2 cursor-pointer"
                    >
                      <div class="flex items-center">
                        <EyeIcon class="w-8 h-8 text-brand-green" />
                      </div>
                      <div class="flex items-center pl-3">
                        <p class="text-base">Preview application</p>
                      </div>
                    </router-link>

                    <router-link
                      :to="{
                        name: 'dashboard_form_edit',
                        params: { slug: apptemp.slug }
                      }"
                      class="flex flex-row border-b border-brand-light-gray py-2 cursor-pointer"
                    >
                      <div class="flex items-center">
                        <PencilAltIcon class="w-8 h-8 text-brand-green" />
                      </div>
                      <div class="flex items-center pl-3">
                        <p class="text-base">Edit</p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { CogIcon, EyeIcon, PencilAltIcon, ExclamationIcon } from "@heroicons/vue/outline"

export default {
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    CogIcon,
    EyeIcon,
    PencilAltIcon,
    ExclamationIcon
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    apptemp: {
      type: Object
    }
  },
  computed: {
    origin() {
      return location.origin
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    },
    openShareModal() {
      this.$emit("share")

      this.$emit("close", false)
    }
  }
}
</script>
